<!-- LABEL, INPUT & HORIZONTAL GUIDANCE -->
@if (msfps.toggleIndividualSectionFieldPreviewMode) {
  <div class="row">
    <!-- LABEl -->
    <div class="row mb-3">
      <div class="d-inline-flex">
        <span
          class="col--"
          recognizeInput
          [innerHTML]="
            replacePlaceholdersInText(getFieldLabel(fieldPreview).question
              .changingThisBreaksApplicationSecurity) | safeHtml
          "
        ></span
        >&nbsp;
        
        <!--
        @if (getFieldLabel(fieldPreview).mouseOverText) {
          <span class="col--">
            <i
              class="fa-solid fa-circle-question ms-1"
              [title]="getFieldLabel(fieldPreview).mouseOverText"
            ></i>
          </span>
        }
        -->
      </div>
    </div>
    <!-- INPUT -->
    @if (getFieldResponse(fieldPreview).TypeValue=="Attachment" && mode =="previewDisabled"){
      <a style="padding-left: 9px;" id="downloadLink" (click)="downloadFormQuestionAttachment(fieldPreview.data[0].QuestionId,fieldPreview.nodeLogic?.selectedAnswers[0])"> 
        {{fieldPreview.nodeLogic?.selectedAnswers[0]}} <i class="fa-solid fa-download"></i>
      </a>
    } @else{
    <div
      class="row mb-3"
      recognizeInput
      [innerHTML]="
        replacePlaceholdersInText(getFieldResponse(fieldPreview).question
          .changingThisBreaksApplicationSecurity)
          | safeHtml
          | evalScript
      "
    ></div>
     @if (getFieldResponse(fieldPreview).TypeValue=="Attachment" && mode != 'previewDisabled' && fieldPreview.nodeLogic?.selectedAnswers[0]){
      <span style="padding-left: 6px;">{{fieldPreview.nodeLogic?.selectedAnswers[0]}} <a (click)="removeFormQuestionAttachment(fieldPreview.data[0].QuestionId,fieldPreview.nodeLogic?.selectedAnswers[0])"><i class="fa fa-remove"></i></a></span> 
     }
    }
    <!-- HORIZONTAL GUIDANCE -->
    @if (
      getFieldGuidance(fieldPreview)?.question
        ?.changingThisBreaksApplicationSecurity
    ) {
      <div
        class="row"
        [innerHTML]="
          replacePlaceholdersInText(getFieldGuidance(fieldPreview).question
            .changingThisBreaksApplicationSecurity) | safeHtml
        "
      ></div>
    }
  </div>
}

<!-- LABEL, INPUT & VERTICAL GUIDANCE -->
@if (!msfps.toggleIndividualSectionFieldPreviewMode) {
  <div class="row">
    <div class="col">
      <!-- LABEl -->
      <div class="row mb-3">
        <div class="d-inline-flex">
          @if (
            fieldPreview.isQnFieldVisibleOnPreviewArea &&
            !fieldPreview.isQnFieldOptional
          ) {
            <span class="text-danger" title="Mandatory">&ast;</span>
          }
          <span
            class="col--"
            recognizeInput
            [innerHTML]="
              replacePlaceholdersInText(getFieldLabel(fieldPreview).question
                .changingThisBreaksApplicationSecurity) | safeHtml
            "
          ></span
          >&nbsp;
          <!--
          @if (getFieldLabel(fieldPreview).mouseOverText) {
            <span class="col--">
              <i
                class="fa-solid fa-circle-question ms-1"
                [title]="getFieldLabel(fieldPreview).mouseOverText"
              ></i>
            </span>
          }
          -->
        </div> 
      </div>
      <!-- INPUT -->

      @if (getFieldResponse(fieldPreview).TypeValue=="Attachment" && mode =="previewDisabled"){
        <a style="padding-left: 9px;" id="downloadLink" (click)="downloadFormQuestionAttachment(fieldPreview.data[0].QuestionId,fieldPreview.nodeLogic?.selectedAnswers[0])"> 
          {{fieldPreview.nodeLogic?.selectedAnswers[0]}} <i class="fa-solid fa-download"></i>
        </a>
      } @else{
        <div
        class="row mb-3"
        recognizeInput
        [innerHTML]="
          replacePlaceholdersInText(getFieldResponse(fieldPreview).question
            .changingThisBreaksApplicationSecurity)
            | safeHtml
            | evalScript
        "
      ></div>
      @if (getFieldResponse(fieldPreview).TypeValue=="Attachment" && mode != 'previewDisabled' && fieldPreview.nodeLogic?.selectedAnswers[0]){
        <span style="padding-left: 6px;">{{fieldPreview.nodeLogic?.selectedAnswers[0]}} <a (click)="removeFormQuestionAttachment(fieldPreview.data[0].QuestionId,fieldPreview.nodeLogic?.selectedAnswers[0])"><i class="fa fa-remove"></i></a></span> 
       }
      }
     
    </div>
    <!-- VERTICAL GUIDANCE -->
    @if (
      getFieldGuidance(fieldPreview)?.question
        ?.changingThisBreaksApplicationSecurity
    ) {
      <div
        class="col"
        [innerHTML]="
          replacePlaceholdersInText(getFieldGuidance(fieldPreview).question
            .changingThisBreaksApplicationSecurity) | safeHtml
        "
      ></div>
    }
  </div>
}
